'use strict';
jQuery.fn.InitializeAccordions = function () {
    var $accordionModule = $(this);
    var $accordionList = $accordionModule.find('.js-accordion-node');
    var triggerClass = '.js-accordion-trigger';
    var activeClass = 'is-expanded';

    var $toggleAll = $accordionModule.find('.js-accordion-toggle-all');
    if (!$toggleAll.length) {
        $toggleAll = $accordionModule.prev('.accordion__toolbar').find('.js-accordion-toggle-all');
    }

    $accordionModule.unbind('click.Accordions');
    if ($toggleAll.length) {
        $toggleAll.off('click.Accordions');
    }

    $accordionModule.on('click.Accordions', triggerClass, function (ev) {
        ev.preventDefault();
        toggleVisibility($(this));

        var $root = $(this).closest('.tab-content__item');
        if (!$root.length) $root = $accordionModule;

        var $btn = $root.find('.js-accordion-toggle-all').first();
        if (!$btn.length) $btn = $toggleAll;

        syncToggleAllLabel($root, $btn);
    });

    $accordionList.each(function (index, el) {
        if ($(el).data('expanded') === true) {
            var $el = $(el);
            $(el).attr('data-expanded', 'false');
            $el.find('.js-accordion-trigger').addClass(activeClass);
            $el.find('.js-accordion-content').css('display', 'block');
        }
    });

    if ($toggleAll.length) {
        $toggleAll.on('click.Accordions', function (ev) {
            ev.preventDefault();

            var $root = $(this).closest('.tab-content__item');
            if (!$root.length) $root = $accordionModule;

            if (anyExpanded($root)) {
                collapseAll($root);
            } else {
                expandAll($root);
            }
            syncToggleAllLabel($root, $(this));
        });

        syncToggleAllLabel($accordionModule, $toggleAll);
    }

    function toggleVisibility($trigger) {
        $trigger.toggleClass(activeClass);
        $trigger.next().slideToggle();
    }

    function anyExpanded($root) {
        $root = $root && $root.length ? $root : $accordionModule;
        return $root.find(triggerClass + '.' + activeClass).length > 0;
    }

    function expandAll($root) {
        $root = $root && $root.length ? $root : $accordionModule;
        $root.find('.js-accordion-node').each(function (_, node) {
            var $node = $(node);
            var $trigger = $node.find(triggerClass).first();
            if (!$trigger.length) return;

            if (!$trigger.hasClass(activeClass)) {
                $trigger.addClass(activeClass);
                $trigger.next().stop(true, true).slideDown();
            }
        });
    }

    function collapseAll($root) {
        $root = $root && $root.length ? $root : $accordionModule;
        $root.find('.js-accordion-node').each(function (_, node) {
            var $node = $(node);
            var $trigger = $node.find(triggerClass).first();
            if (!$trigger.length) return;

            if ($trigger.hasClass(activeClass)) {
                $trigger.removeClass(activeClass);
                $trigger.next().stop(true, true).slideUp();
            }
        });
    }

    function syncToggleAllLabel($root, $button) {
        var $btn = ($button && $button.length) ? $button : $toggleAll;
        if (!$btn || !$btn.length) return;

        $root = $root && $root.length ? $root : $accordionModule;
        var anyOpen = anyExpanded($root);

        if (anyOpen) {
            $btn
                .attr('aria-expanded', 'true')
                .html('COLLAPSE ALL <span aria-hidden="true">-</span>');
        } else {
            $btn
                .attr('aria-expanded', 'false')
                .html('EXPAND ALL <span aria-hidden="true">+</span>');
        }
    }
};

$(function(){
    var $accordionsNode = $('.js-accordions');
    if ($accordionsNode.length) {
        $accordionsNode.InitializeAccordions();
    }
});